// * ========================================================================
// * News center page news form with filters
// * (No ajax for now)
// * Listens to filter form submit and filter pills clicks.
// * Modifies url parameters according to those selections and reloads page.
// *
// * fyi: check accessible multiselects file for multiselect functionality
// * ========================================================================

'use strict';

//import libaries?

const newsForm = (() => {
  //Global variables
  const urlLocation = window.location;
  const newsFilterForm = document.querySelector('.js-news-filter-form');
  const newsFilterPills = document.querySelectorAll('.js-news-filter-pill');
  const allowedUrlParameters = {
    form: ['year','type','category'],
    other: ['slug','view']
  };
  let formFields = {};

  /**
   * Prevents submit.
   * Saves data from fields that have values.
   * Triggers url modifyer function.
   *
   * @param {Event} event - Submit event
   */
  function _handleSubmit(event) {
    event.preventDefault();
    formFields = {}; //clear old submit
    const formData = new FormData(event.target);

    //Save form field's that have values
    for (const entry of formData.entries()) {
      const key = entry[0]; //name of form field
      const value = entry[1]; //value (might be null)

      //Save data from fields that have values
      if(value) {
        //make sure there is an array to push to
        if(formFields[key]) {
          formFields[key].push(value);
        }else {
          formFields[key] = [];
          formFields[key].push(value);
        }
      }
    }

    _updateUrl();
  }

  /**
   * Sanitizes params in URL.
   * Removes the the param held by pill from all url params.
   * Triggers page reload function.
   *
   * @param {Event} event - Click event
   */
  function _handlePill(event) {
    const removeKey = this.getAttribute('data-multiselect');
    const removeValue = this.getAttribute('data-value');
    let urlParams = urlLocation.search;
    let newUrlParams = '';

    //Keep url params that are allowed e.g. view and paging.
    //Remove url param that was clicked
    urlParams = new URLSearchParams(urlParams.slice(1)); //remove ?
    for (const entry of urlParams.entries()) {
      const key = entry[0]; //name of url param
      const value = entry[1]; //value (might be null, might be comma separated list)

      if((allowedUrlParameters.other.includes(key) || allowedUrlParameters.form.includes(key)) && value) { //sanitize
        if(key === removeKey) { //remove clicked value from the correct key
          const valuesInUrl = value.split(',');
          const newValues = valuesInUrl.filter(value => value !== removeValue); //remove clicked value
          if(newValues.length) {
            newUrlParams += (`&${key}=${newValues.join(',')}`);
          }
        }else {
          newUrlParams += (`&${key}=${value}`);
        }
      }
    }

    //Reload page
    newUrlParams = newUrlParams.slice(1); //remove first &
    _reloadPage(newUrlParams);
  }

  /**
   * Sanitizes params in URL.
   * Modifies form multiselect fields to comma separated list.
   * Combines the url params and form fields to new url params.
   * Triggers page reload function.
   */
  function _updateUrl() {
    let urlParams = urlLocation.search;
    let newUrlParams = '';

    //Modify multiselect params to comma separated list
    for (const key in formFields) {
      newUrlParams += (`&${key}=${formFields[key].join(',')}`);
    }

    //Keep other url params that are allowed e.g. view and paging.
    urlParams = new URLSearchParams(urlParams.slice(1)); //remove ?
    for (const entry of urlParams.entries()) {
      const key = entry[0]; //name of url param
      const value = entry[1]; //value (might be null)

      if(allowedUrlParameters.other.includes(key) && value) {
        newUrlParams += (`&${key}=${value}`);
      }
    }

    //Reload page / let the submit pass
    newUrlParams = newUrlParams.slice(1); //remove first &
    _reloadPage(newUrlParams);
  }

  /**
   * Reloads the same page with new url parameters
   *
   * @param {string} newUrlParams - modified url parameters for reloading news center page
   */
  function _reloadPage(newUrlParams) {
    const urlOrigin = urlLocation.origin;
    const urlPath = urlLocation.pathname;

    //Reload page / let the submit pass
    location.replace(urlOrigin + urlPath + '?' + newUrlParams);
  }

  /**
   * Listeners
   */
  function init() {
    //Form submit
    if(newsFilterForm) {
      newsFilterForm.addEventListener('submit', _handleSubmit);
    }

    //Pill click
    newsFilterPills.forEach(pill =>
      pill.addEventListener('click', _handlePill)
    );
  }

  return {
    init: init
  };

})();

export default newsForm;
